export default "__VITE_ASSET__b4a6ce0d__"